import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Date, NameSurname, Status } from "./contactlistCol";


//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";
import Dropzone from 'react-dropzone-uploader';

import {
  getSliders as onGetSliders,
  addSlider as onAddSlider,
  updateSlider as onUpdateSlider,
  deleteSlider as onDeleteSlider,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Randevu Listesi | Dr Randevu ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [selectedAppointmentDetails, setSelectedAppointmentDetails] = useState(null); // New state for appointment details

  const [getFileName, setFileName] = useState('');


  const [getFileSubMediaAdd, setFileSubMediaAdd] = useState([]);

  const [getJobAdvID, setJobAdvID] = useState(null);
  const [getForumID, setForumID] = useState(null);
  const [getNewsID, setNewsID] = useState(null);

  const [getNews, setNews] = useState([]);
  const [getForum, setForum] = useState([]);
  const [getJobAdv, setJobAdv] = useState([]);
  const [getIsActive, setIsActive] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      title: (contactEdit && contactEdit.Sliders_Title) || "",

    },
    validationSchema: Yup.object({


    }),
    onSubmit: values => {
      if (isEdit) {

        const updateUser = {
          ID: contactEdit.ID,
          Sliders_Image: getFileName,
          Sliders_Title:values.title,
          SliderTypeId:getCategoryID,

          News_ID:getNewsID,
          Forum_ID:getForumID,
          Job_Advertisement_ID:getJobAdvID,
          SportCheck:getIsActive

        };
        
        dispatch(onUpdateSlider(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        const newUser = {
       
          Sliders_Image: getFileName,
          Sliders_Title:values["title"],
          SliderTypeId: parseInt(getCategoryID),

          News_ID:parseInt(getNewsID),
          Forum_ID:parseInt(getForumID),
          Job_Advertisement_ID:parseInt(getJobAdvID),
          SportCheck:getIsActive
        };
        console.log("newUser123",newUser)
        // save new user
        dispatch(onAddSlider(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.sliders,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);
  const [detailModal, setDetailModal] = useState(false); // New state for detail modal


  const [isEdit, setIsEdit] = useState(false);


  const [getCategoryID, setCategoryID] = useState(null);


  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },

      {
        Header: "Kullanıcı Adı",
        accessor: "Users.Customer_NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      
     {
        Header: "Doktor",
        accessor: "Doctors.Doctor_NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      
        {
        Header: "Randevu Kategorisi",
        accessor: "Meeting_Category.Meeting_Category_Title",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
            

      {
        Header: "Oluşturulma Tarihi",
        accessor: "Created_DateTime",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />;
        },
      },

        {
        Header: "Başlangıç Tarihi",
        accessor: "Start_DateTime",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />;
        },
      },

        {
        Header: "Bitiş Tarihi",
        accessor: "Finish_DateTime",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />;
        },
      },
     
       {
              Header: "İşlemler",
              Cell: cellProps => {
                return (
                  <div className="d-flex gap-3">
      
                   
                    <Link
                      to="#"
                      className="text-success"
                      onClick={() => {
                        const userData = cellProps.row.original;
                        handleViewDetailsClick(userData); // Updated to handle view details
                      }}
                    >
                      <i className="mdi mdi-eye font-size-18" id="edittooltip" />
                      <UncontrolledTooltip placement="top" target="edittooltip">
                        Detayları Görüntüle
                      </UncontrolledTooltip>
                    </Link>
                    <Link
                      to="#"
                      className="text-danger"
                      onClick={() => {
                        const userData = cellProps.row.original;
                        onClickDelete(userData);
                      }}
                    >
                      <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                      <UncontrolledTooltip placement="top" target="deletetooltip">
                        Sil
                      </UncontrolledTooltip>
                    </Link>
                  </div>
                );
              },
            },

    ],
    []
  );



  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetSliders());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };

  const toggleDetailModal = () => { // New toggle function for detail modal
    setDetailModal(!detailModal);
  };


  const handleUserClick = (arg) => { // This function seems to be for editing/adding, not viewing details
    const user = arg;

    setEditContact(user);


    setCategoryID(user.SliderTypeId)
    setFileName(user.Sliders_Image)

    setForumID(user.Forum_ID)
    setJobAdvID(user.Job_Advertisement_ID)
    setNewsID(user.News_ID)
    setIsEdit(true);
    setIsActive(user.SportCheck)
    toggle();
  };

  const handleViewDetailsClick = (appointmentData) => { // New function to handle viewing details
    setSelectedAppointmentDetails(appointmentData);
    toggleDetailModal();
  };


  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteSlider(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const _setChoiceNews = arg => {
    setNewsID(arg.target.value)
  }
  const _setChoiceForum = arg => {
    setForumID(arg.target.value)
  }

  const _setChoiceJobAdv = arg => {
    setJobAdvID(arg.target.value)
  }

  const Preview = ({ meta }) => {
    const { name, percent, status, previewUrl } = meta;
    return (
      <div className="preview-box">
        <img src={previewUrl} /> <span className="name">{name}</span> - <span className="status">{status == "done" ? "Başarıyla Yüklendi" : "Yükleniyor"}</span>{status !== "done" && <span className="percent"> ({Math.round(percent)}%)</span>}
      </div>
    )
  }


  const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body }
  }

  const handleChangeStatusBanner = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response)
          console.log("lnslkdf", result.file)
          setFileSubMediaAdd(oldArray => [{ fileName: result.file.filename, fileType: result.file.mimetype }, ...oldArray]);
        }
      }
    }
  }
  const handleChangeStatus = ({ xhr }) => {
    if (xhr) {
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          const result = JSON.parse(xhr.response);
          setFileName(result.file.filename)

        }
      }
    }
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Randevu Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddSlider={false}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
             
             
                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Randevu Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Başlık</Label>
                              <Input
                                name="title"
                                label="title"
                                type="text"
                                placeholder="Başlık Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.title || ""}
                                invalid={
                                  validation.touched.title &&
                                    validation.errors.title
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.title &&
                                validation.errors.title ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.title}
                                </FormFeedback>
                              ) : null}
                            </div>



                            <div className="mb-3">
                              <Label className="form-label">Haber Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getNewsID}
                                onChange={(text) => _setChoiceNews(text)}
                                value={
                                  getNewsID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getNews.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.News_Title}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Forum Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getForumID}
                                onChange={(text) => _setChoiceForum(text)}
                                value={
                                  getForumID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getForum.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Forum_Title}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>


                            <div className="mb-3">
                              <Label className="form-label">İlan Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getJobAdvID}
                                onChange={(text) => _setChoiceJobAdv(text)}
                                value={
                                  getJobAdvID
                                }>
                                  <option value="">Lütfen Seçim Yapınız</option>

                                {getJobAdv.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Job_Advertisement_Title}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>

                    
                           

                            <div className="mb-3">
                              <Col xs={12} className="mb-3">
                                <label htmlFor="resume">Görsel</label>
                                <Dropzone
                                  getUploadParams={getUploadParams}
                                  onChangeStatus={handleChangeStatus}
                                  styles={{
                                    dropzone: { overflow: 'auto', border: '1px solid #999', background: '#f5f5f5' },
                                    inputLabelWithFiles: { margin: '20px 3%' }
                                  }}

                                  canRemove={false}
                                  PreviewComponent={Preview}
                                  accept="image/*"
                                />

                              </Col>

                              <div>
                <img
                  className=" avatar-xl"
                  src={'https://megasubdomain.stechomeyazilim.info/' + getFileName}
                  alt=""
                />
                </div>

                            </div>


                            <div className="d-flex">
                              <label htmlFor="resume">Spora Yönlendir?</label>

                              <div className="square-switch">

                                <input
                                  type="checkbox"
                                  id="square-switch1"
                                  className="switch"
                                  defaultChecked={getIsActive}
                                  onChange={() =>
                                    setIsActive(!getIsActive)
                                  }
                                />
                                <label
                                  htmlFor="square-switch1"
                                  data-on-label="Aktif "
                                  data-off-label="Pasif"
                                />
                              </div>

                            </div>

                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>

                  {/* Detail Modal */}
                  <Modal isOpen={detailModal} toggle={toggleDetailModal} centered size="lg">
                    <ModalHeader toggle={toggleDetailModal} tag="h4">
                      Randevu Detayları
                    </ModalHeader>
                    <ModalBody>
                      {selectedAppointmentDetails && (
                        <div>
                          <Row className="mb-3">
                            <Col md="6">
                              <p className="mb-0"><strong>ID:</strong> {selectedAppointmentDetails.ID}</p>
                            </Col>
                            <Col md="6">
                              <p className="mb-0"><strong>Telefon Numarası:</strong> {selectedAppointmentDetails.User_Telephone_Number}</p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md="6">
                              <p className="mb-0"><strong>Müşteri Adı Soyadı:</strong> {selectedAppointmentDetails.User_Name_Surname}</p>
                            </Col>
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Ay Aralığı:</strong> {selectedAppointmentDetails.User_Appointment_Month_Range}</p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Ay ve Gün:</strong> {selectedAppointmentDetails.Users_Appointment_Detail_MonthAndDay}</p>
                            </Col>
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Saatleri:</strong> {selectedAppointmentDetails.Users_Appointment_Detail_Hours}</p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col md="6">
                              <p className="mb-0"><strong>Cinsiyet:</strong> {selectedAppointmentDetails.User_Gender}</p>
                            </Col>
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Açıklaması:</strong> {selectedAppointmentDetails.User_Appointment_Text}</p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                           { selectedAppointmentDetails.Users_Appointment_Created_Date && (  
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Oluşturma Tarihi:</strong> {new Date(selectedAppointmentDetails.Users_Appointment_Created_Date).toLocaleString()}</p>
                            </Col> )}
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Saati:</strong> {selectedAppointmentDetails.Users_Appointment_Time}</p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            { selectedAppointmentDetails.Users_Appointment_Detail_StartDate && (  
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Başlangıç Tarihi:</strong> {new Date(selectedAppointmentDetails.Users_Appointment_Detail_StartDate).toLocaleString()}</p>
                            </Col>)}

                             { selectedAppointmentDetails.Users_Appointment_Detail_FinishDate && (  
                            <Col md="6">
                              <p className="mb-0"><strong>Randevu Bitiş Tarihi:</strong> {new Date(selectedAppointmentDetails.Users_Appointment_Detail_FinishDate).toLocaleString()}</p>
                            </Col>)}
                          </Row>
                          {selectedAppointmentDetails.Users_Appoinment_Attachment && (
                            <Row className="mb-3">
                              <Col xs="12">
                                <p className="mb-0"><strong>Ek Dosya:</strong> <a href={`https://megasubdomain.stechomeyazilim.info/${selectedAppointmentDetails.Users_Appoinment_Attachment}`} target="_blank" rel="noopener noreferrer">Görüntüle</a></p>
                              </Col>
                            </Row>
                          )}
                        </div>
                      )}
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);